const toggledWrappers = document.querySelectorAll( '.toggled-content-wrapper' );

toggledWrappers.forEach( wrapper => {
	const title = wrapper.querySelector( '.toggled-title' );
	const content = wrapper.querySelector( '.toggled-content' );

	if ( ! title || ! content ) {
		return;
	}

	content.classList.add( 'hidden' );

	title.addEventListener( 'click', e => {
		e.preventDefault();
		content.classList.toggle( 'hidden' );
	} );
} );
